import {css} from '@emotion/core'
import styled from '@emotion/styled'
import {
  white,
  darkBlue,
  lightestBlue,
  MQ,
} from '@css/constants'
import { FontNormal } from '@css/fonts'

export const TRANSITION_DELAY = 400

const getTranslationY = (state: string): number => {
  switch (state) {
    case 'exiting':
      return -100
    default:
      return 0
  }
}

export const InfoBannerWrapper = styled('div')<{ state: string }>(props => css`
  height: ${props.state === 'exiting' ? 0 : 48}px;
  transition: height ${TRANSITION_DELAY}ms;
  position: relative;
  width: 100%;
  z-index: ${props.state === 'entering' || props.state === 'exiting' ? -1 : 0};
`)

export const InnerWrapper = styled('div')<{ state: string }>(props => css`
  color: ${white};
  background: ${darkBlue};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 7px 0;
  width: 100%;

  transform: translateY(${getTranslationY(props.state)}%);
  transition: opacity ${TRANSITION_DELAY}ms, transform ${TRANSITION_DELAY}ms;
  opacity: ${props.state === 'entering' || props.state === 'exiting' ? 0 : 1};
`)

export const MessageWrapper = styled('div')(css`
  ${FontNormal(600)};
  font-size: 16px;
  margin-left: 6px;

  ${MQ.SMALL_SCREENS} {
    font-size: 14px;
    margin-right: 70px;
  }
`)

export const IconWrapper = styled('div')(css`
  color: ${lightestBlue};
  position: relative;
  top: 2px;
  margin-left: 4px;
`)

export const CloseBtnWrapper = styled('div')(css`
  position: absolute;
  right: 20px;
`)

export const closeButtonStyles = css`
  padding: 0;
  height: 40px;
  width: 40px;

  & > svg {
    color: ${white};
    height: 20px;
    width: 20px;
  }
`
